import React from 'react';
import PropTypes from 'prop-types';
import InfiniteScroll from './InfiniteScroll';
import ListWithLoadMore from './ListWithLoadMore';
import Loader from '../Loader';

class InfiniteScrollWithLoadMore extends React.Component {
  render() {
    return this.props.showLoadMore ?
      <ListWithLoadMore {...this.props} />
      :
      <InfiniteScroll {...this.props} loader={<Loader block/>}/>;
  }
}

InfiniteScrollWithLoadMore.propTypes = {
  pageStart: PropTypes.number,
  hasMore: PropTypes.bool.isRequired,
  loadMore: PropTypes.func.isRequired,
  threshold: PropTypes.number,
  loader: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  children: PropTypes.node,
  className: PropTypes.string,
  showLoadMore: PropTypes.bool,
  loadMoreLabel: PropTypes.string,
}

export default InfiniteScrollWithLoadMore;



// WEBPACK FOOTER //
// ./src/components/InfiniteScroll/InfiniteScrollWithLoadMore.js